<template lang="pug">
v-app
    WarningSelect(v-show="!estabelecimentoSelecionado")
    v-layout(row, wrap, v-if="$root.user && estabelecimentoSelecionado")
      v-flex(lg12, pb-0)
        v-card.pa-3.br-10.cardPadrao
          v-layout(row, wrap)
            v-flex.md5.xs12.pa-2.areaTempo.br-10.ma-2(style="min-width: 48%", v-if="delivery && delivery.dias_entrega && delivery.dias_entrega !== ''")
              v-flex.md12.xs12
                .subheading Tempo de entrega ({{secToMin(tempo_entrega)}})
              v-flex.md12.xs12.pt-0.pb-0
                v-slider.pa-0(track-color="#c1c1c1", v-model="tempo_entrega", show-ticks="always" ,thumb-label="always", :thumb-size="24", :step="5", :min="5", :max="180", color="primary", @change="atualizarTempoEntrega", :hide-details="true")
            v-spacer(style="max-width:25px", v-if="delivery && delivery.dias_entrega && delivery.dias_entrega !== ''")
            v-flex.md5.xs12.pa-2.areaTempo.br-10.ma-2(style="min-width: 48%", v-if="delivery && delivery.dias_retirada && delivery.dias_retirada !== ''")
              v-flex.md12.xs12
                .subheading Tempo de retirada ({{secToMin(tempo_retirada)}})
              v-flex.md12.xs12.pt-0.pb-0
                v-slider(:always-dirty="true", track-color="#c1c1c1", v-model="tempo_retirada", thumb-label="always", :thumb-size="25", :step="5", :min="0", :max="180", color="primary", @change="atualizarTempoRetirada", :hide-details="true")

          v-card-text.pa-2.mt-2(v-if="$root.user")
            v-layout(row, wrap)
              v-flex.md3.xs12.cardConfig.br-10.pa-2.mt-2
                .subheading Alerta Sonoro
                v-list(v-if="$root.optionsRingtones", style="background-color: transparent !important;")
                  v-list-tile(v-for="(opt,index) in $root.optionsRingtones", :key="index")
                    v-list-tile-action
                      v-btn(icon, @click="changeRingtone(opt)")
                        v-icon(color="primary") {{ ($root.ringtone && $root.ringtone.id == opt.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    v-list-tile-title.body-1.gray--text(style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.nome }}
                    v-list-tile-action
                      v-tooltip(top)
                        v-btn(icon, slot="activator", @click="play(opt)")
                          v-icon(color="primary") play_arrow
                        label Ouvir

              v-flex.md3.xs12.cardConfig.br-10.pa-2.mt-2
                .subheading Tipo de impressão
                v-list(v-if="$root.optionsDrivers", style="background-color: transparent !important;")
                  v-list-tile(v-for="(opt,index) in $root.optionsDrivers", :key="index")
                    v-list-tile-action
                      v-btn(icon, @click="changeDriver(opt)")
                        v-icon(color="primary") {{ ($root.driver && $root.driver.id == opt.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    v-list-tile-content(style="height: auto;")
                      v-list-tile-title.body-1.gray--text(style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.nome }}
                      v-list-tile-sub-title.caption.gray--text(v-if="opt.descricao", style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.descricao }}

              v-flex.md3.xs12.cardConfig.br-10.pa-2.mt-2
                .subheading Impressão de pedidos
                v-list(v-if="$root.optionsPrinters", style="background-color: transparent !important;")
                  v-list-tile(v-for="(opt,index) in $root.optionsPrinters", :key="index")
                    v-list-tile-action
                      v-btn(icon, @click="changePrint(opt)")
                        v-icon(color="primary") {{ ($root.print && $root.print.id == opt.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    v-list-tile-title.body-1.gray--text(style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.nome }}

              v-flex.md3.xs12.cardConfig.br-10.pa-2.mt-2
                .subheading Layout de impressão
                v-list(v-if="$root.optionsLayout", style="background-color: transparent !important;")
                  v-list-tile(v-for="(opt,index) in $root.optionsLayout", :key="index")
                    v-list-tile-action
                      v-btn(icon, @click="changeLayout(opt)")
                        v-icon(color="primary") {{ ($root.printLayout && $root.printLayout.id == opt.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    v-list-tile-title.body-1.gray--text(style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.nome }}
                    v-list-tile-action
                      v-menu(open-on-hover, :close-on-content-click="false", left, offset-x, max-width="240", content-class="layout-preview-menu")
                        v-btn(icon, slot="activator")
                          v-icon(color="grey darken-1", small) visibility
                        v-card
                          print-layout-preview(:layout="opt.id")

              v-flex.md3.xs12.cardConfig.br-10.pa-2.mt-2
                .subheading Confirmação de pedidos
                v-list(v-if="$root.optionsConfirmation", style="background-color: transparent !important;")
                  v-list-tile(v-for="(opt,index) in $root.optionsConfirmation", :key="index")
                    v-list-tile-action
                      v-btn(icon, @click="changeConfirmation(opt)")
                        v-icon(color="primary") {{ ($root.confirmation && $root.confirmation.id == opt.id) ? 'radio_button_checked' : 'radio_button_unchecked' }}
                    v-list-tile-title.body-1.gray--text(style="white-space: normal; overflow: visible; text-overflow: unset;") {{ opt.nome }}

            v-layout.pa-0(row, wrap, v-if="$root.driver != null && $root.driver.id == 2")
              v-flex.xs12.pa-0.pt-3
                .subheading.font-weight-bold Instalar impressora:
              v-flex.md6.xs12
                v-list.br-5.lista
                  v-list-tile.mt-2(href="https://www.java.com/pt_BR/download", target="_blank")
                    v-list-tile-action
                      v-icon(color="blue") link
                    v-list-tile-content
                      v-list-tile-title(style="white-space: normal; overflow: visible; text-overflow: unset;") Java (instalador)
                      v-list-tile-sub-title.blue--text(style="white-space: normal; overflow: visible; text-overflow: unset;") https://www.java.com/pt_BR/download
                  v-list-tile.mt-2(href="https://qz.io/download", target="_blank", v-if="$root.driver != null && $root.driver.id == 2")
                    v-list-tile-action
                      v-icon(color="blue") link
                    v-list-tile-content
                      v-list-tile-title(style="white-space: normal; overflow: visible; text-overflow: unset;") QZ Tray
                      v-list-tile-sub-title.blue--text(style="white-space: normal; overflow: visible; text-overflow: unset;") https://qz.io/download
            v-layout(row, wrap)
              v-flex.xs12.pa-0.pt-3
                .subheading.font-weight-bold Suporte Remoto:
              v-flex.md6.xs12
                v-list.br-5.lista
                  v-list-tile(href="https://www.teamviewer.com/pt/download", target="_blank")
                    v-list-tile-action
                      v-icon(color="blue") link
                    v-list-tile-content
                      v-list-tile-title(style="white-space: normal; overflow: visible; text-overflow: unset;") TeamViewer (instalador)
                      v-list-tile-sub-title.blue--text(style="white-space: normal; overflow: visible; text-overflow: unset;") https://www.teamviewer.com/pt/download
            v-layout(row, wrap)
              v-flex.md6.xs12
                v-list.br-5.lista
                  v-list-tile(href="https://anydesk.com/pt/downloads", target="_blank")
                    v-list-tile-action
                      v-icon(color="blue") link
                    v-list-tile-content
                      v-list-tile-title(style="white-space: normal; overflow: visible; text-overflow: unset;") AnyDesk (instalador)
                      v-list-tile-sub-title.blue--text(style="white-space: normal; overflow: visible; text-overflow: unset;") https://anydesk.com/pt/downloads
    OnboardingFab(etapa="etapa_configuracoes")

</template>

<script>
import _ from 'lodash';
import alert1 from '@/assets/audio/alert.mp3';
import alert2 from '@/assets/audio/ringtone.mp3';
import WarningSelect from '@/components/WarningSelect';
import OnboardingFab from '@/components/OnboardingFab';
import PrintLayoutPreview from '@/components/PrintLayoutPreview';

export default {
  components:{
    WarningSelect,
    OnboardingFab,
    PrintLayoutPreview,
  },
  data: () => ({
    delivery: null,
    tempo_entrega: null,
    tempo_retirada: null
  }),
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
  },
  created () {

    if(!this.$root.ringtone || !this.$root.ringtone.id) this.$root.selectRingtone(this.$root.optionsRingtones[0]);
    if(!this.$root.driver || !this.$root.driver.id) this.$root.selectDriver(this.$root.optionsDrivers[0]);
    if(!this.$root.print || !this.$root.print.id) this.$root.selectPrint(this.$root.optionsPrinters[0]);
    if(!this.$root.printLayout || !this.$root.printLayout.id) this.$root.selectPrintLayout(this.$root.optionsLayout[0]);
    if(!this.$root.confirmation || !this.$root.confirmation.id) this.$root.selectConfirmation(this.$root.optionsConfirmation[0]);

    window.getApp.$on("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
    window.getApp.$on("APP_UPDATE_DELIVERY", this.onUpdateDelivery);
  },
  beforeDestroy() {
    window.getApp.$off("CHANGE_ESTABELECIMENTO", this.onChangeEstabelecimento);
    window.getApp.$off("APP_UPDATE_DELIVERY", this.onUpdateDelivery);
  },
  mounted(){
    this.onChangeEstabelecimento()
  },
  watch: {
  },
  methods: {
    onUpdateDelivery(data){
      this.delivery = data;
      this.tempo_entrega = data.tempo_entrega;
      this.tempo_retirada = data.tempo_retirada;
    },
    onChangeEstabelecimento(){
      console.log('CHANGE_ESTABELECIMENTO CONFIG', this.estabelecimentoSelecionado)
      if(this.estabelecimentoSelecionado)
        this.setConfig(this.estabelecimentoSelecionado)
    },
    setConfig(estabelecimento){
      this.delivery = _.cloneDeep(estabelecimento.delivery[0]);
      this.tempo_entrega = this.delivery.tempo_entrega;
      this.tempo_retirada = this.delivery.tempo_retirada;
    },
    async update (delivery) {
      try {
        const response = await this.$axios.put('/delivery', delivery);
        window.getApp.$emit('APP_UPDATE_DELIVERY', response.data);
      } catch (error) {
        window.getApp.$emit('APP_ALERT', { color: 'red', text: "Erro ao salvar os dados. Tente novamente!" });
      }
    },

    atualizarTempoEntrega () {
      this.delivery.tempo_entrega = this.tempo_entrega;
      this.update(this.delivery);
    },
    atualizarTempoRetirada () {
      this.delivery.tempo_retirada = this.tempo_retirada;
      this.update(this.delivery);
    },

    secToMin(minutes) {
      if (!minutes) return '00:00';

      let hours = Math.floor(minutes / 60);
      let remainingMinutes = minutes % 60;
      let result = '';

      if (hours > 0) {
        result += hours > 1 ? `${hours} horas` : `${hours} hora`;
      }

      if (remainingMinutes > 0) {
        if(result.length > 0){
          result += ', ';
        }
        result += remainingMinutes > 1 ? `${remainingMinutes} minutos` : `${remainingMinutes} minuto`;
      }

      return result;
    },

    changePrint (opt) {
      this.$root.selectPrint(opt);
    },

    changeDriver (opt) {
      this.$root.selectDriver(opt);
    },

    changeRingtone (opt) {
      this.$root.selectRingtone(opt);
    },

    changeLayout (opt) {
      this.$root.selectPrintLayout(opt);
    },

    changeConfirmation (opt) {
      this.$root.selectConfirmation(opt);
    },

    play (opt) {
      new Audio(opt.id == 1 ? alert1 : alert2).play();
    },

  }
}
</script>

<style scoped>
.Poppins{
    font-family: "Poppins", "Roboto", "Helvetica";
  }
  .Captalize{
    text-transform: capitalize !important;
  }
  .conteudo {
    min-height: 100px;
    height: 100px;
  }
  .br-5{
      border-radius: 5px !important;
  }
  .br-10{
      border-radius: 10px !important;
  }
  .cardPadrao{
    box-shadow:none !important;
    background-color: transparent;
  }
  .areaTempo{
    border: 1px solid #c1c1c1;
    background-color: #ececec69;
  }
  .btnFechar{
    right: 10px;
    color: #111312cc;
    text-transform: capitalize;
    width: 100%;
    background-color: #ffb0b0 !important;
    border: 1px solid #da8e8e !important;
  }
  .btnAbrir{
    right: 10px;
    color: #111312cc;
    text-transform: capitalize;
    width: 100%;
    background-color: rgb(227, 240, 233) !important;
    border-color: rgb(227, 240, 233) !important;
  }
  .btnDentroFechar{
    background-color: #f95858;
  }
  .custom-color {
  display: inline-block;
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  margin-right: 5px;
  border-radius: 5px;
}
.custom-color i {
  transform: translateY(-1px) !important;
}
.cardConfig{
  background-color: #ececec69;
  border-right: 5px solid #fafafa;
  border-left: 5px solid #fafafa;
}
.lista{
  background-color: #ececec69;
}
</style>
